<template>
  <div class="auditLogListContainer">
    <el-skeleton :rows="6" animated v-if="_loading" />
    <el-timeline v-if="!_loading && list.length > 0">
      <el-timeline-item v-for="(content, index) in list" :key="index" :icon="content.icon"
        :color="index === 0 ? content.color : ''">

        <div class="audit-item-container">
          <div class="content">
            <p class="audit-content">{{ content.content }}</p>
            <p class="message">
            <div v-if="content.submitContent" class="submit-content">
              <div style="width: 75px;">提交内容：</div>
              <div style="flex: 1" class="content" v-html="content.submitContent"></div>
            </div>
            <div v-if="content.replayContent" class="replay-content">
              <div style="width: 75px;">回复内容：</div>
              <div style="flex: 1" v-html="content.replayContent"></div>
            </div>
            </p>
          </div>

          <p class="audit-timestamp">{{ content.timestamp }}</p>
        </div>
      </el-timeline-item>
    </el-timeline>
    <el-empty v-if="list.length === 0 && !_loading" :image-size="100" description="暂无审核记录"></el-empty>
  </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
  name: 'auditLogList',
  props: {
    auditLogList: {
      type: Array || null,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      _loading: false
    };
  },

  watch: {
    loading: {
      handler(val) {
        this._loading = val
      },
      immediate: true
    },
    auditLogList: {
      handler(val) {
        if (val.length > 0) {
          const data = val.map(item => {
            let obj = {}
            obj.submitContent = ''
            obj.replayContent = ''
            obj.icon = ''
            if (+item.auditlogtype === 1) {
              obj.content = `${item.username}：提交审核`
              obj.color = '#909399'
              obj.submitContent = `${!!item.auditlogcontent ? item.auditlogcontent.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;') : ''}`

            }
            if (+item.auditlogtype === 1 && +item.auditresult === 1) {
              obj.content = `${item.username}：通过`
              obj.color = '#67C23A'
              obj.icon = 'el-icon-check'
            }
            if (+item.auditlogtype === 2) {
              obj.replayContent = `${!!item.auditlogcontent ? item.auditlogcontent.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;') : ''}`
              if (+item.auditresult === 1) {
                obj.content = `${item.username}：通过`
                obj.color = '#67C23A'
                obj.icon = 'el-icon-check'
              }
              if (+item.auditresult === 2) {
                obj.replayConten = `${!!item.auditlogcontent ? item.auditlogcontent.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;') : ''}`
                obj.content = `${item.username}：驳回`
                obj.color = '#F56C6C'
                obj.icon = 'el-icon-close'
              }
              if (+item.auditresult === 3) {
                obj.replayContent = `${!!item.auditlogcontent ? item.auditlogcontent.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;') : ''}`
                obj.content = `${item.username}：拒绝`
                obj.color = '#F56C6C'
                obj.icon = 'el-icon-close'
              }
            }
            obj.timestamp = dayjs(item.auditlogtime).format('YYYY-MM-DD HH:mm:ss')
            return obj
          })
          this.list = data
        } else {
          this.list = []
        }
      },
      deep: true, // 深度监听user对象内部属性的变化
      immediate: true // 在Vue实例创建时立即执行一次handler
    }

  },
}
</script>
<style scoped>
.auditLogListContainer {
  min-height: 80px;
  max-height: 600px;
  overflow-y: auto;

  .audit-item-container {
    .audit-timestamp {
      color: #909399;
      line-height: 1;
      font-size: 12px;
    }

    .audit-content {
      color: #303133;
      word-wrap: break-word;
      word-break: break-all;
      font-size: 16px;
    }

    .replay-content {
      font-weight: bold;
      color: #F56C6C
    }

    .replay-content,
    .submit-content {
      display: flex;
    }
  }

}
</style>
